import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getBrandConfig } from './brandConfig';
import { Button } from './components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './components/ui/card';
import { Input } from './components/ui/input';
import { Label } from './components/ui/label';

const brand = getBrandConfig();
const logoUrl = brand.logoUrl || '/brand-logo.png';

export default function Login({ onLoginSuccess = () => { } }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://ia.discador.net';

  // const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/';


  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await axios.post(`${baseUrl}/login`, {
        email,
        password
      });
      const { token: responseToken, user } = response.data;
      localStorage.setItem('token', responseToken);
      
      // Salvar a API Key da Vapi como tokenClient (se existir)
      if (user.vapiApiKey) {
        localStorage.setItem('tokenClient', user.vapiApiKey);
        console.log("Token salvo como tokenClient");
      } else {
        // Se não houver token, limpar o tokenClient antigo
        localStorage.removeItem('tokenClient');
        console.log("Usuário não possui token configurado");
      }

      // Salvar o OrgID no localStorage (se existir)
      if (user.orgID) {
        localStorage.setItem('orgID', user.orgID);
        console.log("OrgID salvo no localStorage");
      } else {
        // Se não houver OrgID, limpar o orgID antigo
        localStorage.removeItem('orgID');
        console.log("Usuário não possui OrgID configurado");
      }

      localStorage.setItem('userData', JSON.stringify({
        id: user.id,
        clienteId: user.clienteId || user.id,
        role: user.role,
        tenantId: user.tenantId || null,
      }));
      localStorage.setItem('userRole', user.role || 'cliente');

      // Se o usuário tiver tenantId, buscar branding desse tenant
      try {
        if (user.tenantId) {
          const config = {
            headers: {
              Authorization: `Bearer ${responseToken}`,
            },
          };
          const brandingRes = await axios.get(
            `${baseUrl}/api/tenants/${user.tenantId}/branding`,
            config
          );
          if (brandingRes.data && brandingRes.data.branding) {
            localStorage.setItem('tenantBranding', JSON.stringify(brandingRes.data.branding));
          } else {
            localStorage.removeItem('tenantBranding');
          }
        } else {
          localStorage.removeItem('tenantBranding');
        }
      } catch (brandingErr) {
        console.error('Erro ao carregar branding do tenant:', brandingErr);
        localStorage.removeItem('tenantBranding');
      }
      onLoginSuccess(); // Chama a função para atualizar o estado de autenticação
      navigate('/dashboard');
    } catch (err) {
      console.error('Erro ao efetuar login:', err);
      if (err.response && err.response.status === 401) {
        setError('E-mail ou senha incorretos.');
      } else {
        setError('Ocorreu um erro. Tente novamente mais tarde.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md border-border/60 bg-card/95 shadow-xl backdrop-blur">
        <CardHeader className="space-y-4 pb-4">
          <div className="flex justify-center">
            <img src={logoUrl} alt={`${brand.name} Logo`} className="w-80" />
          </div>
          <CardTitle className="text-center text-2xl text-foreground">Acesse seu Painel</CardTitle>
        </CardHeader>
        <CardContent>
          <form className="space-y-5" onSubmit={handleLogin}>
            <div className="space-y-2">
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seuemail@exemplo.com"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Sua senha"
              />
            </div>
            {error && (
              <p className="text-sm text-destructive text-center">{error}</p>
            )}
            <Button type="submit" disabled={loading} className="w-full">
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
